module.exports = __webpack_public_path__ + "static/media/backArrowDisabled.5905fb79.svg";